





























































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import PressurePO from "@/store/entities/devices/pressure/pressurepo";
import Url from "@/lib/url";
import XLSX from "@/lib/Common/excel";
@Component({
  components: {},
})
export default class ImportPressure extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  entity: PressurePO = new PressurePO();
  loading: boolean = false;
  areaTree: [] = [];
  modelType: any[] = [];
  meterList: any[] = [];
  actionUrl: string = "";
  importing: boolean = false;
  create() {}
  created() {
    this.getmodelType();
    this.getItemDetail();
    this.getMeterList();
    this.actionUrl = Url + "api/services/app/FileCommonService/UploadFile";
  }
  cancel() {
    (this.$refs.itemForm as any).resetFields();

    this.$emit("input", false);
  }
  get list() {
    return this.$data.tableData;
  }
  visibleChange(value: boolean) {
    if (!value) {
      this.$data.tableData = [];
      this.$emit("save-success");
      this.$emit("input", value);
    }
  }
  //下载模板
  downloadtemplat() {
    let a = document.createElement("a");
    a.href = "@/assets/download/pressure.xlsx";
    a.click();
  }
  //上传文件
  handleUpload(file) {
    const fileExt = file.name.split(".").pop().toLocaleLowerCase();
    //console.log(fileExt)
    if (fileExt == "xlsx" || fileExt == "xls") {
      this.loading = true;
      this.readFile(file);
      this.$data.file = file;
    } else {
      this.$Modal.info({
        title: this.L("Tips"),
        content: this.L("UpLoadFielException"),
      });
    }
    return false;
  }
  // 读取文件
  readFile(file) {
    const reader = new FileReader();
    reader.readAsArrayBuffer(file);
    reader.onerror = (e) => {
      this.$Message.error("文件读取出错");
      this.loading = false;
    };
    reader.onload = (e) => {
      this.$Message.info("文件读取成功");
      const data = (e.target as any).result;
      const { header, results } = XLSX.read(data, "array");

      const tableTitle = header.map((item) => {
        return { title: item, key: item };
      });
      this.$data.tableData = results;
      this.$data.tableTitle = tableTitle;
      this.loading = false;
    };
  }
  //列信息
  columns = [
    {
      type: "index",
      width: 60,
      align: "left",
      fixed: "left",
      title: this.L("IndexNo"),
    },
    {
      type: "selection",
      width: 60,
      align: "center",
      fixed: "left",
    },
    {
      title: this.L("Organizations"),
      key: "organizationId",
      width: 130,
      sortId: 5,
      render: (h: any, params: any) => {
        let id = params.row.organizationId;
        let ite = JSON.parse(localStorage.getItem("organizations"));
        let info = ite.filter((p) => {
          return p.id == id;
        });
        return h("div", [
          h(
            "span",
            {
              style: {
                display: "inline-block",
                width: "100%",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              },
              domProps: {
                title:
                  info.length > 0 ? info[0].displayName : this.L("Unknown"),
              },
            },
            info.length > 0 ? info[0].displayName : this.L("Unknown")
          ),
        ]);
      },
    },
    {
      title: this.L("Areas"),
      key: "areaId",
      sortable: true,
      width: 160,
      render: (h: any, params: any) => {
        let id = params.row.areaId;
        let ite = JSON.parse(localStorage.getItem("areas"));
        let info = ite.filter((p) => {
          return p.id == id;
        });
        return h(
          "span",
          info.length > 0 ? info[0].fullName : this.L("Unknown")
        );
      },
    },
    {
      title: this.L("DeviceNo"),
      key: "deviceNo",
      width: 160,
      fixed: "left",
      sortable: true,
    },
    {
      sortable: true,
      title: this.L("CollectorId"),
      key: "collectorId",
      width: 130,
      sortId: 7,
      render: (h: any, params: any) => {
        let id = params.row.collectorId;
        let info = this.$data.collectorList.filter((p) => {
          return p.id == id;
        });
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: info.length > 0 ? info[0].no : this.L("DirectLink"),
            },
          },
          info.length > 0 ? info[0].no : this.L("DirectLink")
        );
      },
    },
    {
      sortable: true,
      title: this.L("ModelInfo"),
      key: "modelId",
      width: 130,
      sortId: 18,
      render: (h: any, params: any) => {
        let id = params.row.modelId;
        let info = this.modelType.filter((p) => {
          return p.value == id;
        });
        return h("span", info.length > 0 ? info[0].label : this.L("Unknown"));
      },
    },
    {
      title: this.L("Location"),
      key: "location",
      width: 130,
      sortId: 17,
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: params.row.location,
            },
          },
          params.row.location
        );
      },
    },
    {
      title: this.L("Imei"),
      key: "imei",
      width: 160,
      render: (h: any, params: any) => {
        return h("div", [
          h(
            "span",
            {
              style: {
                display: "inline-block",
                width: "100%",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              },
              domProps: { title: params.row.imei },
            },
            params.row.imei
          ),
        ]);
      },
    },
    {
      title: this.L("IMSI"),
      key: "iMSI",
      width: 160,
      render: (h: any, params: any) => {
        return h("div", [
          h(
            "span",
            {
              style: {
                display: "inline-block",
                width: "100%",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              },
              domProps: { title: params.row.iMSI },
            },
            params.row.iMSI
          ),
        ]);
      },
    },
    {
      title: this.L("ICCID"),
      key: "iCCID",
      width: 160,
      render: (h: any, params: any) => {
        return h("div", [
          h(
            "span",
            {
              style: {
                display: "inline-block",
                width: "100%",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              },
              domProps: { title: params.row.iCCID },
            },
            params.row.iCCID
          ),
        ]);
      },
    },
    {
      title: this.L("DeviceType"),
      key: "deviceType",
      width: 160,
      render: (h: any, params: any) => {
        let id = params.row.deviceType;
        let ite = JSON.parse(localStorage.getItem("itemdetail"));
        let info = ite.filter((p) => {
          return p.id == id;
        });
        return h("span", info.length > 0 ? info[0].name : this.L("Unknown"));
      },
    },
    {
      title: this.L("ISP"),
      key: "iSP",
      width: 130,
      render: (h: any, params: any) => {
        let id = params.row.isp;
        let ite = JSON.parse(localStorage.getItem("itemdetail"));
        let info = ite.filter((p) => {
          return p.id == id;
        });
        return h("span", info.length > 0 ? info[0].name : this.L("Unknown"));
      },
    },
    {
      title: this.L("Transfer") + this.L("Category"),
      key: "transferType",
      width: 130,
      sortable: true,
      sortId: 21,
      render: (h: any, params: any) => {
        let id = params.row.transferType;
        let ite = JSON.parse(localStorage.getItem("itemdetail"));
        let info = ite.filter((p) => {
          return p.id == id;
        });
        return h("span", info.length > 0 ? info[0].name : "未知");
      },
    },
    {
      title: this.L("IsSec"),
      key: "isSec",
      width: 90,
      sortId: 29,
      render: (h: any, params: any) => {
        return h(
          "span",
          params.row.isSec == true ? this.L("Yes") : this.L("No")
        );
      },
    },
    {
      title: this.L("Unit"),
      key: "unitName",
      width: 130,
      sortId: 51,
    },
    {
      title: this.L("Magnification"),
      key: "magnification",
      width: 130,
      sortId: 52,
    },
    {
      title: this.L("AesKey"),
      key: "aesKey",
      width: 130,
      sortId: 30,
      render: (h: any, params: any) => {
        return h("div", [
          h(
            "span",
            {
              style: {
                display: "inline-block",
                width: "100%",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              },
              domProps: { title: params.row.aesKey },
            },
            params.row.aesKey
          ),
        ]);
      },
    },
    {
      title: "AppId",
      key: "appId",
      width: 130,
      render: (h: any, params: any) => {
        return h("div", [
          h(
            "span",
            {
              style: {
                display: "inline-block",
                width: "100%",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              },
              domProps: { title: params.row.appId },
            },
            params.row.appId
          ),
        ]);
      },
    },
    {
      title: "AppSecret",
      key: "appSecret",
      width: 130,
      render: (h: any, params: any) => {
        return h("div", [
          h(
            "span",
            {
              style: {
                display: "inline-block",
                width: "100%",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              },
              domProps: { title: params.row.appSecret },
            },
            params.row.appSecret
          ),
        ]);
      },
    },
    {
      title: this.L("Protocol"),
      key: "protocol",
      width: 160,
      render: (h: any, params: any) => {
        let id = params.row.protocol;
        let ite = JSON.parse(localStorage.getItem("itemdetail"));
        let info = ite.filter((p) => {
          return p.id == id;
        });
        return h("span", info.length > 0 ? info[0].name : this.L("Unknown"));
      },
    },
    {
      title: this.L("AepTenantId"),
      key: "aepTenantId",
      width: 130,
    },
    {
      title: this.L("ProductId"),
      key: "productId",
      width: 130,
      render: (h: any, params: any) => {
        return h("div", [
          h(
            "span",
            {
              style: {
                display: "inline-block",
                width: "100%",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              },
              domProps: { title: params.row.productId },
            },
            params.row.productId
          ),
        ]);
      },
    },
    {
      title: this.L("MasterId"),
      key: "masterId",
      width: 130,
      render: (h: any, params: any) => {
        return h("div", [
          h(
            "span",
            {
              style: {
                display: "inline-block",
                width: "100%",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              },
              domProps: { title: params.row.masterId },
            },
            params.row.masterId
          ),
        ]);
      },
    },
    {
      title: this.L("ManufacturerId"),
      key: "manufacturerId",
      width: 130,
    },
    {
      title: this.L("ManufacturerName"),
      key: "manufacturerName",
      width: 130,
    },
    {
      title: this.L("DeviceModel"),
      key: "deviceModel",
      width: 130,
    },
    {
      title: this.L("Obj_Id"),
      key: "obj_Id",
      width: 130,
    },
    {
      title: this.L("Obj_Inst_id"),
      key: "obj_Inst_id",
      width: 130,
    },
    {
      title: this.L("Res_Id"),
      key: "res_Id",
      width: 130,
    },
    {
      title: this.L("Supplier"),
      key: "supplierId",
      width: 130,
      sortable: true,
      sortId: 20,
      render: (h: any, params: any) => {
        let id = params.row.supplierId;
        let ite = JSON.parse(localStorage.getItem("suppliers"));
        let info = ite.filter((p) => {
          return p.id == id;
        });
        return h("span", info.length > 0 ? info[0].name : "未知");
      },
    },
    {
      title: this.L("ISPDeviceId"),
      key: "ispDeviceId",
      width: 130,
      sortId: 46,
      render: (h: any, params: any) => {
        return h("div", [
          h(
            "span",
            {
              style: {
                display: "inline-block",
                width: "100%",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              },
              domProps: { title: params.row.ispDeviceId },
            },
            params.row.ispDeviceId
          ),
        ]);
      },
    },
    {
      sortable: true,
      title: this.L("IsActive"),
      key: "isEnable",
      width: 130,
      sortId: 45,
      render: (h: any, params: any) => {
        return h(
          "span",
          params.row.isEnable == 1 ? this.L("Yes") : this.L("No")
        );
      },
    },
    {
      title: this.L("SortName"),
      key: "sortCode",
      width: 130,
      sortId: 47,
    },
    {
      title: this.L("Description"),
      key: "description",
      width: 130,
      sortId: 48,
      render: (h: any, params: any) => {
        return h("div", [
          h(
            "span",
            {
              style: {
                display: "inline-block",
                width: "100%",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              },
              domProps: { title: params.row.description },
            },
            params.row.description
          ),
        ]);
      },
    },
    {
      title: "Id",
      key: "id",
      width: 130,
      render: (h: any, params: any) => {
        return h("div", [
          h(
            "span",
            {
              style: {
                display: "inline-block",
                width: "100%",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              },
              domProps: { title: params.row.id },
            },
            params.row.id
          ),
        ]);
      },
    },
  ];
  //采集器模型
  async getmodelType() {
    await this.$store
      .dispatch("collectormodel/getalllist")
      .then((val) => {
        if (val.length > 0) {
          val.forEach((ele) => {
            this.modelType.push({ label: ele.name, value: ele.id });
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }
  //数据字典
  getItemDetail() {
    if (localStorage.getItem("itemdetail") === null) {
      this.$store.dispatch({
        type: "itemdetail/getdetailtolocalstorge",
      });
    }
    let detaillist = JSON.parse(localStorage.getItem("itemdetail"));
    if (detaillist.length > 0) {
      let info = detaillist.filter((p) => {
        return p.itemId == 8;
      });
      info.forEach((ele) => {
        this.$data.applicationType.push({
          label: ele.name,
          value: ele.id,
        });
      });
      let trans = detaillist.filter((p) => {
        return p.itemId == 13;
      });
      trans.forEach((ele) => {
        this.$data.transferType.push({
          label: ele.name,
          value: ele.id,
        });
      });
      let metert = detaillist.filter((p) => {
        return p.itemId == 7;
      });
      metert.forEach((ele) => {
        this.$data.meterType.push({
          label: ele.name,
          value: ele.id,
        });
      });
      let control = detaillist.filter((p) => {
        return p.itemId == 14;
      });
      control.forEach((ele) => {
        this.$data.controleType.push({
          label: ele.name,
          value: ele.id,
        });
      });
    }
  }
  //获取采集器
  async getCollectorList() {
    await this.$store
      .dispatch("collector/getalllist")
      .then((val) => {
        if (val.length > 0) {
          val.forEach((ele) => {
            this.$data.collectorList.push(ele);
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }
  //获取表列表
  async getMeterList() {
    await this.$store
      .dispatch("meter/getalllist")
      .then((val) => {
        if (val.length > 0) {
          val.forEach((ele) => {
            this.meterList.push(ele);
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }
  //导入数据
  async importData() {
    if (this.$data.tableData.length == 0) {
      this.$Modal.info({
        title: this.L("Tips"),
        content: this.L("NoDatas"),
      });
      return;
    }
    this.importing = true;
    let res = await this.$store
      .dispatch({
        type: "meter/importMeter",
        data: this.$data.tableData,
      })
      .catch((err) => {
        this.importing = false;
        this.$Modal.info({
          title: this.L("Tips"),
          content: err,
        });
      });
    this.importing = false;
    if (res.data.success == true) {
      this.$data.tableData = res.data.result;
    } else {
      this.$Modal.info({
        title: this.L("Tips"),
        content: res.data.error,
      });
    }
  }
  //数据
  data() {
    return {
      file: null,
      applicationType: [],
      transferType: [],
      meterType: [],
      controleType: [],
      ispdetail: [],
      collectorList: [],
      tableData: [],
      tableTitle: [],
      normalizer(node) {
        if (node.children && !node.children.length) {
          delete node.children;
        }
        return {
          id: node.id,
          label: node.label,
          children: node.children,
        };
      },
    };
  }
}
